import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { apiService } from '../../api/api';

function CcAvenueRedirectPage() {
  const { txnId } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);

  useEffect(() => {
    let timeout;
    const fetchAndSubmit = async () => {
      try {
        const fullUrl = `api/orders/get-ccavenue-otk-details/${txnId}`;
        const data = await apiService.get(fullUrl);

        if (!data.ccAvenueInitTxnURL || !data.encryptedData || !data.accessCode) {
          console.error('Missing CCAvenue parameters');
          setError(true);
          return;
        }

        // Create and submit form
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = data.ccAvenueInitTxnURL;
        form.target = '_self';
        form.style.display = 'none';

        const encRequestInput = document.createElement('input');
        encRequestInput.type = 'hidden';
        encRequestInput.name = 'encRequest';
        encRequestInput.value = data.encryptedData;
        form.appendChild(encRequestInput);

        const accessCodeInput = document.createElement('input');
        accessCodeInput.type = 'hidden';
        accessCodeInput.name = 'access_code';
        accessCodeInput.value = data.accessCode;
        form.appendChild(accessCodeInput);

        document.body.appendChild(form);

        // ⏱️ Set fallback timeout in case redirect fails
        timeout = setTimeout(() => {
          console.warn('Payment request failed or was blocked');
          setError(true);
        }, 10000); // 10 seconds

        form.submit();
      } catch (err) {
        console.error('CCAvenue redirection error:', err);
        setError(true);
      }
    };

    fetchAndSubmit();

    return () => clearTimeout(timeout); // Cleanup timeout if component unmounts
  }, [txnId]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
      textAlign: 'center',
    }}
    >
      {!error ? (
      // eslint-disable-next-line react/react-in-jsx-scope
        <>
          <h2>Redirecting to payment gateway...</h2>
          <p>Please do not refresh or press back.</p>
        </>
      ) : (
        <>
          <h2 style={{ marginTop: '3rem' }}>Payment link expired</h2>
          <p>Please retry payment after some time.</p>
        </>
      )}
    </div>
  );
}

export default CcAvenueRedirectPage;
